
import React from 'react';
import { useApp } from '../context/AppContext';

const AdaptiveLogo: React.FC = () => {
  const { config } = useApp();

  return (
    <svg 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className="w-full h-full"
    >
      {/* Minimalist Geometric Logo - Intersecting Circles/Arcs */}
      <circle cx="50" cy="50" r="40" stroke={config.primaryColor} strokeWidth="2" />
      <path 
        d="M30 50 A20 20 0 0 1 70 50" 
        stroke={config.primaryColor} 
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path 
        d="M70 50 A20 20 0 0 1 30 50" 
        stroke={config.secondaryColor} 
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="50" cy="50" r="4" fill={config.primaryColor} />
    </svg>
  );
};

export default AdaptiveLogo;
